const waitForVoices = () => {
  const voices = window.speechSynthesis.getVoices();
  if (voices.length > 0) return Promise.resolve(voices);

  return new Promise((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      window.speechSynthesis.removeEventListener('voiceschanged', finish);
      resolve(window.speechSynthesis.getVoices());
    };

    window.speechSynthesis.addEventListener('voiceschanged', finish, { once: true });
    window.setTimeout(finish, 800);
  });
};

const findPreferredVoice = (voices, language) => {
  const languagePrefix = language.split('-')[0].toLowerCase();
  const exactVoices = voices.filter((voice) => voice.lang.toLowerCase() === language.toLowerCase());
  const matchingVoices = exactVoices.length > 0
    ? exactVoices
    : voices.filter((voice) => voice.lang.toLowerCase().startsWith(languagePrefix));
  const findByPriority = (names) => names.reduce(
    (preferred, name) => preferred || matchingVoices.find(
      (voice) => voice.name.toLowerCase().includes(name.toLowerCase())
    ),
    null
  );

  if (languagePrefix === 'zh') {
    return findByPriority(['Xiaoxiao', 'Yunyang', 'Huihui', 'Ting-Ting', 'Meijia', 'Sin-ji'])
      || matchingVoices.find((voice) => voice.localService)
      || matchingVoices[0];
  }

  const englishVoices = voices.filter((voice) => voice.lang.toLowerCase().startsWith('en-'));
  const femaleEnglishVoices = englishVoices.filter((voice) => /Samantha|Karen|Moira|Tessa|Shelley|Flo|Sandy|Ava/i.test(voice.name));
  const findFemaleByPriority = (names) => names.reduce(
    (preferred, name) => preferred || femaleEnglishVoices.find(
      (voice) => voice.name.toLowerCase().includes(name.toLowerCase())
    ),
    null
  );

  return findFemaleByPriority([
    'Samantha',
    'Ava',
    'Karen',
    'Moira',
    'Tessa',
    'Shelley',
    'Flo',
    'Sandy'
  ])
    || matchingVoices.find((voice) => !/samantha|Daniel|Eddy|Reed|Rocko|Grandpa/i.test(voice.name))
    || matchingVoices[0];
};

export const speakText = async (text, language) => {
  if (!('speechSynthesis' in window) || !text) return;

  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = language;
  utterance.rate = 1.0;
  utterance.pitch = 1;
  utterance.volume = 1;

  const voices = await waitForVoices();
  const voice = findPreferredVoice(voices, language);
  if (voice) utterance.voice = voice;

  window.speechSynthesis.speak(utterance);
};
